import InfoEmployee from './components/InfoEmployee.vue'

const router = {
  name: 'infoEmployee',
  path: '/infoEmployee/:id',
  component: InfoEmployee,
  meta: {
    showMenu: false,
    requiresAuth: true,
    requiresPermission: true,
    action: 53,
    titleHeader: 'Datos del empleado'
  }
}

export default router